export const AMS_SYNC_LOGS = 'AMS Sync Logs';
export const UNIVERSAL_ROWS_EXPORT = 'Univ. Rows Export';
